import TransferMoneyContainer from 'containers/transferMoney';

export default {
  exact: true,
  name: 'transfer-money',
  protected: true,
  path: '/transfer-money',
  component: TransferMoneyContainer,
};
